<template>
  <div>
    <!-- Project and player name -->
    <v-row no-gutters>
      <v-col cols="12">
        <span class="text-h6 accent--text" v-text="value.projectName" />
        <span> - </span>
        <span
          class="subtitle-1 primary--text"
          v-text="playerName"
        />
      </v-col>
    </v-row>

    <!-- Start Week Informations -->
    <v-row justify="center" align="center" no-gutters>
      <v-col
        cols="auto"
        style="width: 50px"
        v-text="$t('animation.multiproject.general.start')"
      />
      <v-col cols="auto">
        <v-row no-gutters>
          <v-col v-if="!ccpm" cols="6" class="py-2 px-1">
            <v-card flat width="90px" height="30px">
              <v-card-text class="pa-1 px-3">
                <span>
                  {{ $t('animation.multiproject.general.planned') }}
                  {{
                    $t('animation.multiproject.general.weekFirstLetter')
                      + value.weekStartPlanned
                  }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col :cols="ccpm ? 12 : 6" class="py-2 px-1">
            <v-card
              flat
              width="90px"
              height="30px"
              :color="!value.weekStartReal ? 'blue-grey lighten-2' : ''"
            >
              <v-card-text v-if="value.weekStartReal" class="pa-1">
                <span>
                  {{ $t('animation.multiproject.general.real') }}
                  {{ $t('animation.multiproject.general.weekFirstLetter') + value.weekStartReal }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- End Week Informations -->
    <v-row justify="center" align="center" no-gutters>
      <v-col
        cols="auto"
        style="width: 50px"
        v-text="$t('animation.multiproject.general.end')"
      />
      <v-col cols="auto">
        <v-row no-gutters>
          <v-col v-if="!ccpm" cols="6" class="py-2 px-1">
            <v-menu
              v-model="isVisibleHistory"
              :close-on-content-click="false"
              nudge-width="80"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  :class="isVisibleHistory ? 'primary' : ''"
                  flat
                  width="90px"
                  height="30px"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-card-text
                    :class="isVisibleHistory ? 'white--text' : ''"
                    class="pa-1"
                  >
                    <span>
                      {{ $t('animation.multiproject.general.planned') }}
                      {{ $t('animation.multiproject.general.weekFirstLetter')
                        + value.weekEndPlanned }}
                    </span>
                  </v-card-text>
                </v-card>
              </template>

              <v-list color="primary">
                <v-list-item v-if="historyList.length === 0">
                  <v-list-item-title class="white--text">
                    <span v-text="$t('animation.multiproject.general.noHistory')" />
                  </v-list-item-title>
                </v-list-item>

                <template v-for="(history, index) in historyList" v-else>
                  <v-list-item
                    :key="`history-${index}`"
                    style="min-height: 30px;"
                  >
                    <v-list-item-title class="white--text">
                      <span v-text="history.round" />
                      <span class="text-decoration-line-through" v-text="history.oldPlanned" />
                      <span> -> </span>
                      <span v-text="history.newPlanned" />
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </v-col>

          <v-col :cols="ccpm ? 12 : 6" class="py-2 px-1">
            <v-card
              flat
              width="90px"
              height="30px"
              :color="!value.weekEndReal ? 'blue-grey lighten-2' : ''"
            >
              <v-card-text v-if="value.weekEndReal" class="pa-1">
                <span>
                  {{ $t('animation.multiproject.general.real') }}
                  {{ $t('animation.multiproject.general.weekFirstLetter') + value.weekEndReal }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ProjectInformation',
  props: {
    value: {
      type: Object,
      required: true,
    },
    ccpm: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isVisibleHistory: false,
  }),
  computed: {
    historyList () {
      const roundText = this.$tc('animation.multiproject.general.round')
      const weekText = this.$tc('animation.multiproject.general.weekFirstLetter')

      return this.value.historyWeekEndPlanned.map(item => ({
        ...item,
        round: `${roundText} ${item.round} : `,
        oldPlanned: `${weekText}${item.oldPlanned}`,
        newPlanned: `${weekText}${item.newPlanned}`,
      }))
    },
    playerName () {
      if (this.value.auto) {
        return this.$t('animation.multiproject.general.auto')
      }
      return this.value.playerName || this.$t('animation.multiproject.general.notPlayerName')
    },
  },
}
</script>
